import React, { useState } from 'react'
import cn from 'classnames'

import { MarketTextField } from '../MarketTextField/MarketTextField'
import { ActionButton } from '../ActionButton/ActionButton'
import { CheckBox } from '../../../components/CheckBox/CheckBox'

import { ReactComponent as Tick } from '../../../assets/icons/tick.svg'

import { numSpaces, strNumOnly } from '../../../utils/functions'
import { MARKET_MIN_AMOUNT } from '../../../utils/const'

import './TransformChange.scss'

export const TransformChange = ({
  label,
  checkLabel,
  max,
  min,
  amount,
  actionResult,
  onChange,
  onAccept,
}) => {
  const [show, setShow] = useState(false)
  const [checked, setChecked] = useState(false)

  const onChangeAmount = e => {
    let str = e.target.value
    onChange(strNumOnly(str))
  }

  const onClick = () => {
    if (show) onAccept()

    setShow(!show)
  }

  const notBaseMin = amount >= MARKET_MIN_AMOUNT
  const notMin = min ? amount >= min : true
  const notMax = max ? amount <= max : true

  return (
    <div
      className={
        cn(
          'transform-change-container',
          { show },
          { error: show && amount && (!notBaseMin || !notMax || !notMin) },
          { success: actionResult }
        )
      }
    >
      <MarketTextField
        placeholder="AMMOUNT IN TRX"
        disabled={ !show }
        value={ amount }
        onChange={ onChangeAmount }
      />
      <div className="button-wrapper">
        <ActionButton
          label={ label }
          blue
          disabled={
            (
              show
              && (!checked || !notBaseMin || !notMax || !notMin)
            )
            || (
              max
              && max === MARKET_MIN_AMOUNT
            )
          }
          onClick={ onClick }
        />
      </div>
      <div className="error-container">
        <span>
          { !notBaseMin && `MIN AMMOUNT IS ${ numSpaces(MARKET_MIN_AMOUNT) } TRX` }
          { !notMax && `MEOW, YOUR BID IS HIGHER THAN THE MARKET PRICE` }
          { !notMin && notMax && notBaseMin && `MEOW, YOUR BID IS LOWER THAN THE CURRENT BID` }
        </span>
      </div>
      <div className="checkbox-wrapper">
        <CheckBox
          label={ checkLabel }
          blue
          checked={ checked }
          onChange={ () => setChecked(!checked) }
        />
      </div>
      <div className="success-container">
        <span>
          { actionResult }
        </span>
        { actionResult !== 'ERROR' && <Tick /> }
      </div>
    </div>
  )
}